import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type StationeryPrintOrderFieldsFragment = {
  __typename?: 'StationeryPrintOrder';
  id: string;
  createdAt: any;
  priceInMinorUnits: number;
  quantity: number;
  deliveryMethod: Types.StationeryPrintOrderDeliveryMethodEnum;
  currentStatus: Types.StationeryPrintOrderStatusEnum;
  orderNumber: string;
  ownerId: string;
  eventId?: string | null;
  designSetName?: string | null;
  printCardFrontPreviewUrl: string;
  printCardBackPreviewUrl: string;
  vendor: Types.StationeryPrintOrderVendorEnum;
  cardDraft?: {
    __typename?: 'StationeryDraft';
    id: string;
    ownerId: string;
    eventId?: string | null;
    stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; themeId: string; category: Types.StationeryTemplateCategoryEnum };
  } | null;
  printPayment?: { __typename?: 'StationeryPrintOrderPayment'; id: string; stationeryPrintOrderId: string; salesOrderId: string; paid: boolean; paidAt?: any | null } | null;
  shippingAddress?: {
    __typename?: 'StationeryPrintOrderShippingAddress';
    name: string;
    address1: string;
    address2?: string | null;
    city: string;
    region: string;
    postalCode: string;
    country: string;
    countryCode: string;
  } | null;
  issues: Array<{
    __typename?: 'StationeryPrintOrderIssue';
    id: string;
    resolvedAt?: any | null;
    issueType: Types.StationeryPrintOrderIssueType;
    issueTarget: Types.StationeryPrintOrderIssueTarget;
    additionalUserFacingDescription?: string | null;
  }>;
};

export type GetStationeryPrintOrdersQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.StationeryPrintOrdersFiltersInput>;
  pagination?: Types.InputMaybe<Types.StationeryPrintOrdersPaginationInput>;
}>;

export type GetStationeryPrintOrdersQuery = {
  __typename?: 'Query';
  stationeryPrintOrders: {
    __typename?: 'StationeryPrintOrdersView';
    count?: number | null;
    orders: Array<{
      __typename?: 'StationeryPrintOrder';
      id: string;
      createdAt: any;
      priceInMinorUnits: number;
      quantity: number;
      deliveryMethod: Types.StationeryPrintOrderDeliveryMethodEnum;
      currentStatus: Types.StationeryPrintOrderStatusEnum;
      orderNumber: string;
      ownerId: string;
      eventId?: string | null;
      designSetName?: string | null;
      printCardFrontPreviewUrl: string;
      printCardBackPreviewUrl: string;
      vendor: Types.StationeryPrintOrderVendorEnum;
      cardDraft?: {
        __typename?: 'StationeryDraft';
        id: string;
        ownerId: string;
        eventId?: string | null;
        stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; themeId: string; category: Types.StationeryTemplateCategoryEnum };
      } | null;
      printPayment?: { __typename?: 'StationeryPrintOrderPayment'; id: string; stationeryPrintOrderId: string; salesOrderId: string; paid: boolean; paidAt?: any | null } | null;
      shippingAddress?: {
        __typename?: 'StationeryPrintOrderShippingAddress';
        name: string;
        address1: string;
        address2?: string | null;
        city: string;
        region: string;
        postalCode: string;
        country: string;
        countryCode: string;
      } | null;
      issues: Array<{
        __typename?: 'StationeryPrintOrderIssue';
        id: string;
        resolvedAt?: any | null;
        issueType: Types.StationeryPrintOrderIssueType;
        issueTarget: Types.StationeryPrintOrderIssueTarget;
        additionalUserFacingDescription?: string | null;
      }>;
    }>;
  };
};

export type GetStationeryAllOrdersQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.StationeryPrintOrdersFiltersInput>;
  pagination?: Types.InputMaybe<Types.StationeryPrintOrdersPaginationInput>;
}>;

export type GetStationeryAllOrdersQuery = {
  __typename?: 'Query';
  stationeryAllOrders: {
    __typename?: 'StationeryPrintOrdersView';
    count?: number | null;
    orders: Array<{
      __typename?: 'StationeryPrintOrder';
      id: string;
      createdAt: any;
      priceInMinorUnits: number;
      quantity: number;
      deliveryMethod: Types.StationeryPrintOrderDeliveryMethodEnum;
      currentStatus: Types.StationeryPrintOrderStatusEnum;
      orderNumber: string;
      ownerId: string;
      eventId?: string | null;
      designSetName?: string | null;
      printCardFrontPreviewUrl: string;
      printCardBackPreviewUrl: string;
      vendor: Types.StationeryPrintOrderVendorEnum;
      cardDraft?: {
        __typename?: 'StationeryDraft';
        id: string;
        ownerId: string;
        eventId?: string | null;
        stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; themeId: string; category: Types.StationeryTemplateCategoryEnum };
      } | null;
      printPayment?: { __typename?: 'StationeryPrintOrderPayment'; id: string; stationeryPrintOrderId: string; salesOrderId: string; paid: boolean; paidAt?: any | null } | null;
      shippingAddress?: {
        __typename?: 'StationeryPrintOrderShippingAddress';
        name: string;
        address1: string;
        address2?: string | null;
        city: string;
        region: string;
        postalCode: string;
        country: string;
        countryCode: string;
      } | null;
      issues: Array<{
        __typename?: 'StationeryPrintOrderIssue';
        id: string;
        resolvedAt?: any | null;
        issueType: Types.StationeryPrintOrderIssueType;
        issueTarget: Types.StationeryPrintOrderIssueTarget;
        additionalUserFacingDescription?: string | null;
      }>;
    }>;
  };
};

export type GetStationeryPrintOrderByOrderNumberQueryVariables = Types.Exact<{
  orderNumber: Types.Scalars['String'];
}>;

export type GetStationeryPrintOrderByOrderNumberQuery = {
  __typename?: 'Query';
  stationeryPrintOrderByOrderNumber?: {
    __typename?: 'StationeryPrintOrder';
    id: string;
    createdAt: any;
    priceInMinorUnits: number;
    quantity: number;
    deliveryMethod: Types.StationeryPrintOrderDeliveryMethodEnum;
    currentStatus: Types.StationeryPrintOrderStatusEnum;
    orderNumber: string;
    ownerId: string;
    eventId?: string | null;
    designSetName?: string | null;
    printCardFrontPreviewUrl: string;
    printCardBackPreviewUrl: string;
    vendor: Types.StationeryPrintOrderVendorEnum;
    cardDraft?: {
      __typename?: 'StationeryDraft';
      id: string;
      ownerId: string;
      eventId?: string | null;
      stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; themeId: string; category: Types.StationeryTemplateCategoryEnum };
    } | null;
    printPayment?: { __typename?: 'StationeryPrintOrderPayment'; id: string; stationeryPrintOrderId: string; salesOrderId: string; paid: boolean; paidAt?: any | null } | null;
    shippingAddress?: {
      __typename?: 'StationeryPrintOrderShippingAddress';
      name: string;
      address1: string;
      address2?: string | null;
      city: string;
      region: string;
      postalCode: string;
      country: string;
      countryCode: string;
    } | null;
    issues: Array<{
      __typename?: 'StationeryPrintOrderIssue';
      id: string;
      resolvedAt?: any | null;
      issueType: Types.StationeryPrintOrderIssueType;
      issueTarget: Types.StationeryPrintOrderIssueTarget;
      additionalUserFacingDescription?: string | null;
    }>;
  } | null;
};

export type CancelStationeryPrintOrderByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type CancelStationeryPrintOrderByIdMutation = { __typename?: 'Mutation'; cancelStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder'; id: string } | null };

export type RefundStationeryPrintOrderByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type RefundStationeryPrintOrderByIdMutation = { __typename?: 'Mutation'; refundStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder'; id: string } | null };

export type PauseStationeryPrintOrderByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type PauseStationeryPrintOrderByIdMutation = { __typename?: 'Mutation'; pauseStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder'; id: string } | null };

export type ResumeStationeryPrintOrderByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type ResumeStationeryPrintOrderByIdMutation = { __typename?: 'Mutation'; resumeStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder'; id: string } | null };

export type InstantlyProcessStationeryPrintOrderByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type InstantlyProcessStationeryPrintOrderByIdMutation = {
  __typename?: 'Mutation';
  instantlyProcessStationeryPrintOrderById?: { __typename?: 'StationeryPrintOrder'; id: string } | null;
};

export type UpdateStationeryPrintOrderShippingAddressMutationVariables = Types.Exact<{
  data: Types.UpdateStationeryPrintOrderShippingAddressInput;
}>;

export type UpdateStationeryPrintOrderShippingAddressMutation = { __typename?: 'Mutation'; updateStationeryPrintOrderShippingAddress?: any | null };

export type CombineStationeryPrintOrdersMutationVariables = Types.Exact<{
  data: Types.BundleStationeryPrintOrderInput;
}>;

export type CombineStationeryPrintOrdersMutation = { __typename?: 'Mutation'; combineStationeryPrintOrders?: any | null };

export type SetStationeryDigitalPrintOrderFeatureSmsMutationVariables = Types.Exact<{
  data: Types.SetStationeryDigitalPrintOrderFeatureSmsInput;
}>;

export type SetStationeryDigitalPrintOrderFeatureSmsMutation = { __typename?: 'Mutation'; setStationeryDigitalPrintOrderFeatureSms?: any | null };

export type SetStationeryDigitalPrintOrderQuantityMutationVariables = Types.Exact<{
  data: Types.SetStationeryDigitalPrintOrderQuantityInput;
}>;

export type SetStationeryDigitalPrintOrderQuantityMutation = { __typename?: 'Mutation'; setStationeryDigitalPrintOrderQuantity?: any | null };

export const StationeryPrintOrderFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPrintOrderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cardDraft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'printPayment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryPrintOrderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salesOrderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designSetName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issues' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueTarget' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalUserFacingDescription' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardFrontPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardBackPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetStationeryPrintOrdersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStationeryPrintOrders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrdersFiltersInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrdersPaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryPrintOrders' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'filters' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'pagination' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryPrintOrderFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPrintOrderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cardDraft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'printPayment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryPrintOrderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salesOrderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designSetName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issues' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueTarget' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalUserFacingDescription' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardFrontPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardBackPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetStationeryPrintOrdersQuery__
 *
 * To run a query within a React component, call `useGetStationeryPrintOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryPrintOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryPrintOrdersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetStationeryPrintOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>) {
  return ApolloReactHooks.useQuery<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>(GetStationeryPrintOrdersDocument, baseOptions);
}
export function useGetStationeryPrintOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>(GetStationeryPrintOrdersDocument, baseOptions);
}
export type GetStationeryPrintOrdersQueryHookResult = ReturnType<typeof useGetStationeryPrintOrdersQuery>;
export type GetStationeryPrintOrdersLazyQueryHookResult = ReturnType<typeof useGetStationeryPrintOrdersLazyQuery>;
export type GetStationeryPrintOrdersQueryResult = Apollo.QueryResult<GetStationeryPrintOrdersQuery, GetStationeryPrintOrdersQueryVariables>;
export const GetStationeryAllOrdersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStationeryAllOrders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrdersFiltersInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrdersPaginationInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryAllOrders' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'filters' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'pagination' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryPrintOrderFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPrintOrderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cardDraft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'printPayment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryPrintOrderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salesOrderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designSetName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issues' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueTarget' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalUserFacingDescription' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardFrontPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardBackPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetStationeryAllOrdersQuery__
 *
 * To run a query within a React component, call `useGetStationeryAllOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryAllOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryAllOrdersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetStationeryAllOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryAllOrdersQuery, GetStationeryAllOrdersQueryVariables>) {
  return ApolloReactHooks.useQuery<GetStationeryAllOrdersQuery, GetStationeryAllOrdersQueryVariables>(GetStationeryAllOrdersDocument, baseOptions);
}
export function useGetStationeryAllOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryAllOrdersQuery, GetStationeryAllOrdersQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetStationeryAllOrdersQuery, GetStationeryAllOrdersQueryVariables>(GetStationeryAllOrdersDocument, baseOptions);
}
export type GetStationeryAllOrdersQueryHookResult = ReturnType<typeof useGetStationeryAllOrdersQuery>;
export type GetStationeryAllOrdersLazyQueryHookResult = ReturnType<typeof useGetStationeryAllOrdersLazyQuery>;
export type GetStationeryAllOrdersQueryResult = Apollo.QueryResult<GetStationeryAllOrdersQuery, GetStationeryAllOrdersQueryVariables>;
export const GetStationeryPrintOrderByOrderNumberDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStationeryPrintOrderByOrderNumber' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryPrintOrderByOrderNumber' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'orderNumber' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'orderNumber' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryPrintOrderFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryPrintOrderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cardDraft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'printPayment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stationeryPrintOrderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'salesOrderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'designSetName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issues' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueTarget' } },
                { kind: 'Field', name: { kind: 'Name', value: 'additionalUserFacingDescription' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardFrontPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'printCardBackPreviewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetStationeryPrintOrderByOrderNumberQuery__
 *
 * To run a query within a React component, call `useGetStationeryPrintOrderByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStationeryPrintOrderByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStationeryPrintOrderByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useGetStationeryPrintOrderByOrderNumberQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>(
    GetStationeryPrintOrderByOrderNumberDocument,
    baseOptions,
  );
}
export function useGetStationeryPrintOrderByOrderNumberLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>(
    GetStationeryPrintOrderByOrderNumberDocument,
    baseOptions,
  );
}
export type GetStationeryPrintOrderByOrderNumberQueryHookResult = ReturnType<typeof useGetStationeryPrintOrderByOrderNumberQuery>;
export type GetStationeryPrintOrderByOrderNumberLazyQueryHookResult = ReturnType<typeof useGetStationeryPrintOrderByOrderNumberLazyQuery>;
export type GetStationeryPrintOrderByOrderNumberQueryResult = Apollo.QueryResult<GetStationeryPrintOrderByOrderNumberQuery, GetStationeryPrintOrderByOrderNumberQueryVariables>;
export const CancelStationeryPrintOrderByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelStationeryPrintOrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelStationeryPrintOrderById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<CancelStationeryPrintOrderByIdMutation, CancelStationeryPrintOrderByIdMutationVariables>;

/**
 * __useCancelStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `useCancelStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStationeryPrintOrderByIdMutation, { data, loading, error }] = useCancelStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelStationeryPrintOrderByIdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CancelStationeryPrintOrderByIdMutation, CancelStationeryPrintOrderByIdMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CancelStationeryPrintOrderByIdMutation, CancelStationeryPrintOrderByIdMutationVariables>(CancelStationeryPrintOrderByIdDocument, baseOptions);
}
export type CancelStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof useCancelStationeryPrintOrderByIdMutation>;
export type CancelStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<CancelStationeryPrintOrderByIdMutation>;
export type CancelStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<CancelStationeryPrintOrderByIdMutation, CancelStationeryPrintOrderByIdMutationVariables>;
export const RefundStationeryPrintOrderByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefundStationeryPrintOrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refundStationeryPrintOrderById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RefundStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<RefundStationeryPrintOrderByIdMutation, RefundStationeryPrintOrderByIdMutationVariables>;

/**
 * __useRefundStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `useRefundStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundStationeryPrintOrderByIdMutation, { data, loading, error }] = useRefundStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefundStationeryPrintOrderByIdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RefundStationeryPrintOrderByIdMutation, RefundStationeryPrintOrderByIdMutationVariables>,
) {
  return ApolloReactHooks.useMutation<RefundStationeryPrintOrderByIdMutation, RefundStationeryPrintOrderByIdMutationVariables>(RefundStationeryPrintOrderByIdDocument, baseOptions);
}
export type RefundStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof useRefundStationeryPrintOrderByIdMutation>;
export type RefundStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<RefundStationeryPrintOrderByIdMutation>;
export type RefundStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<RefundStationeryPrintOrderByIdMutation, RefundStationeryPrintOrderByIdMutationVariables>;
export const PauseStationeryPrintOrderByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PauseStationeryPrintOrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pauseStationeryPrintOrderById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PauseStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<PauseStationeryPrintOrderByIdMutation, PauseStationeryPrintOrderByIdMutationVariables>;

/**
 * __usePauseStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `usePauseStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseStationeryPrintOrderByIdMutation, { data, loading, error }] = usePauseStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePauseStationeryPrintOrderByIdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<PauseStationeryPrintOrderByIdMutation, PauseStationeryPrintOrderByIdMutationVariables>,
) {
  return ApolloReactHooks.useMutation<PauseStationeryPrintOrderByIdMutation, PauseStationeryPrintOrderByIdMutationVariables>(PauseStationeryPrintOrderByIdDocument, baseOptions);
}
export type PauseStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof usePauseStationeryPrintOrderByIdMutation>;
export type PauseStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<PauseStationeryPrintOrderByIdMutation>;
export type PauseStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<PauseStationeryPrintOrderByIdMutation, PauseStationeryPrintOrderByIdMutationVariables>;
export const ResumeStationeryPrintOrderByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeStationeryPrintOrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resumeStationeryPrintOrderById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResumeStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<ResumeStationeryPrintOrderByIdMutation, ResumeStationeryPrintOrderByIdMutationVariables>;

/**
 * __useResumeStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `useResumeStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeStationeryPrintOrderByIdMutation, { data, loading, error }] = useResumeStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeStationeryPrintOrderByIdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<ResumeStationeryPrintOrderByIdMutation, ResumeStationeryPrintOrderByIdMutationVariables>,
) {
  return ApolloReactHooks.useMutation<ResumeStationeryPrintOrderByIdMutation, ResumeStationeryPrintOrderByIdMutationVariables>(ResumeStationeryPrintOrderByIdDocument, baseOptions);
}
export type ResumeStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof useResumeStationeryPrintOrderByIdMutation>;
export type ResumeStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<ResumeStationeryPrintOrderByIdMutation>;
export type ResumeStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<ResumeStationeryPrintOrderByIdMutation, ResumeStationeryPrintOrderByIdMutationVariables>;
export const InstantlyProcessStationeryPrintOrderByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InstantlyProcessStationeryPrintOrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantlyProcessStationeryPrintOrderById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InstantlyProcessStationeryPrintOrderByIdMutationFn = Apollo.MutationFunction<
  InstantlyProcessStationeryPrintOrderByIdMutation,
  InstantlyProcessStationeryPrintOrderByIdMutationVariables
>;

/**
 * __useInstantlyProcessStationeryPrintOrderByIdMutation__
 *
 * To run a mutation, you first call `useInstantlyProcessStationeryPrintOrderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstantlyProcessStationeryPrintOrderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instantlyProcessStationeryPrintOrderByIdMutation, { data, loading, error }] = useInstantlyProcessStationeryPrintOrderByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInstantlyProcessStationeryPrintOrderByIdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<InstantlyProcessStationeryPrintOrderByIdMutation, InstantlyProcessStationeryPrintOrderByIdMutationVariables>,
) {
  return ApolloReactHooks.useMutation<InstantlyProcessStationeryPrintOrderByIdMutation, InstantlyProcessStationeryPrintOrderByIdMutationVariables>(
    InstantlyProcessStationeryPrintOrderByIdDocument,
    baseOptions,
  );
}
export type InstantlyProcessStationeryPrintOrderByIdMutationHookResult = ReturnType<typeof useInstantlyProcessStationeryPrintOrderByIdMutation>;
export type InstantlyProcessStationeryPrintOrderByIdMutationResult = Apollo.MutationResult<InstantlyProcessStationeryPrintOrderByIdMutation>;
export type InstantlyProcessStationeryPrintOrderByIdMutationOptions = Apollo.BaseMutationOptions<
  InstantlyProcessStationeryPrintOrderByIdMutation,
  InstantlyProcessStationeryPrintOrderByIdMutationVariables
>;
export const UpdateStationeryPrintOrderShippingAddressDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateStationeryPrintOrderShippingAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateStationeryPrintOrderShippingAddressInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStationeryPrintOrderShippingAddress' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateStationeryPrintOrderShippingAddressMutationFn = Apollo.MutationFunction<
  UpdateStationeryPrintOrderShippingAddressMutation,
  UpdateStationeryPrintOrderShippingAddressMutationVariables
>;

/**
 * __useUpdateStationeryPrintOrderShippingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateStationeryPrintOrderShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStationeryPrintOrderShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStationeryPrintOrderShippingAddressMutation, { data, loading, error }] = useUpdateStationeryPrintOrderShippingAddressMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStationeryPrintOrderShippingAddressMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStationeryPrintOrderShippingAddressMutation, UpdateStationeryPrintOrderShippingAddressMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateStationeryPrintOrderShippingAddressMutation, UpdateStationeryPrintOrderShippingAddressMutationVariables>(
    UpdateStationeryPrintOrderShippingAddressDocument,
    baseOptions,
  );
}
export type UpdateStationeryPrintOrderShippingAddressMutationHookResult = ReturnType<typeof useUpdateStationeryPrintOrderShippingAddressMutation>;
export type UpdateStationeryPrintOrderShippingAddressMutationResult = Apollo.MutationResult<UpdateStationeryPrintOrderShippingAddressMutation>;
export type UpdateStationeryPrintOrderShippingAddressMutationOptions = Apollo.BaseMutationOptions<
  UpdateStationeryPrintOrderShippingAddressMutation,
  UpdateStationeryPrintOrderShippingAddressMutationVariables
>;
export const CombineStationeryPrintOrdersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CombineStationeryPrintOrders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BundleStationeryPrintOrderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'combineStationeryPrintOrders' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CombineStationeryPrintOrdersMutationFn = Apollo.MutationFunction<CombineStationeryPrintOrdersMutation, CombineStationeryPrintOrdersMutationVariables>;

/**
 * __useCombineStationeryPrintOrdersMutation__
 *
 * To run a mutation, you first call `useCombineStationeryPrintOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCombineStationeryPrintOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [combineStationeryPrintOrdersMutation, { data, loading, error }] = useCombineStationeryPrintOrdersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCombineStationeryPrintOrdersMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CombineStationeryPrintOrdersMutation, CombineStationeryPrintOrdersMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CombineStationeryPrintOrdersMutation, CombineStationeryPrintOrdersMutationVariables>(CombineStationeryPrintOrdersDocument, baseOptions);
}
export type CombineStationeryPrintOrdersMutationHookResult = ReturnType<typeof useCombineStationeryPrintOrdersMutation>;
export type CombineStationeryPrintOrdersMutationResult = Apollo.MutationResult<CombineStationeryPrintOrdersMutation>;
export type CombineStationeryPrintOrdersMutationOptions = Apollo.BaseMutationOptions<CombineStationeryPrintOrdersMutation, CombineStationeryPrintOrdersMutationVariables>;
export const SetStationeryDigitalPrintOrderFeatureSmsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetStationeryDigitalPrintOrderFeatureSms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetStationeryDigitalPrintOrderFeatureSmsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setStationeryDigitalPrintOrderFeatureSms' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetStationeryDigitalPrintOrderFeatureSmsMutationFn = Apollo.MutationFunction<
  SetStationeryDigitalPrintOrderFeatureSmsMutation,
  SetStationeryDigitalPrintOrderFeatureSmsMutationVariables
>;

/**
 * __useSetStationeryDigitalPrintOrderFeatureSmsMutation__
 *
 * To run a mutation, you first call `useSetStationeryDigitalPrintOrderFeatureSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStationeryDigitalPrintOrderFeatureSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStationeryDigitalPrintOrderFeatureSmsMutation, { data, loading, error }] = useSetStationeryDigitalPrintOrderFeatureSmsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetStationeryDigitalPrintOrderFeatureSmsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SetStationeryDigitalPrintOrderFeatureSmsMutation, SetStationeryDigitalPrintOrderFeatureSmsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SetStationeryDigitalPrintOrderFeatureSmsMutation, SetStationeryDigitalPrintOrderFeatureSmsMutationVariables>(
    SetStationeryDigitalPrintOrderFeatureSmsDocument,
    baseOptions,
  );
}
export type SetStationeryDigitalPrintOrderFeatureSmsMutationHookResult = ReturnType<typeof useSetStationeryDigitalPrintOrderFeatureSmsMutation>;
export type SetStationeryDigitalPrintOrderFeatureSmsMutationResult = Apollo.MutationResult<SetStationeryDigitalPrintOrderFeatureSmsMutation>;
export type SetStationeryDigitalPrintOrderFeatureSmsMutationOptions = Apollo.BaseMutationOptions<
  SetStationeryDigitalPrintOrderFeatureSmsMutation,
  SetStationeryDigitalPrintOrderFeatureSmsMutationVariables
>;
export const SetStationeryDigitalPrintOrderQuantityDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetStationeryDigitalPrintOrderQuantity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetStationeryDigitalPrintOrderQuantityInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setStationeryDigitalPrintOrderQuantity' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetStationeryDigitalPrintOrderQuantityMutationFn = Apollo.MutationFunction<
  SetStationeryDigitalPrintOrderQuantityMutation,
  SetStationeryDigitalPrintOrderQuantityMutationVariables
>;

/**
 * __useSetStationeryDigitalPrintOrderQuantityMutation__
 *
 * To run a mutation, you first call `useSetStationeryDigitalPrintOrderQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStationeryDigitalPrintOrderQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStationeryDigitalPrintOrderQuantityMutation, { data, loading, error }] = useSetStationeryDigitalPrintOrderQuantityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetStationeryDigitalPrintOrderQuantityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SetStationeryDigitalPrintOrderQuantityMutation, SetStationeryDigitalPrintOrderQuantityMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SetStationeryDigitalPrintOrderQuantityMutation, SetStationeryDigitalPrintOrderQuantityMutationVariables>(
    SetStationeryDigitalPrintOrderQuantityDocument,
    baseOptions,
  );
}
export type SetStationeryDigitalPrintOrderQuantityMutationHookResult = ReturnType<typeof useSetStationeryDigitalPrintOrderQuantityMutation>;
export type SetStationeryDigitalPrintOrderQuantityMutationResult = Apollo.MutationResult<SetStationeryDigitalPrintOrderQuantityMutation>;
export type SetStationeryDigitalPrintOrderQuantityMutationOptions = Apollo.BaseMutationOptions<
  SetStationeryDigitalPrintOrderQuantityMutation,
  SetStationeryDigitalPrintOrderQuantityMutationVariables
>;
